const resources = {
    date: 'Date',
    next2Month: '2 prochains mois et plus',
    nextMonth: 'Le mois prochain',
    next2Weeks: '2 prochaines semaines',
    next7Days: '7 prochains jours',
    sort: 'Trier',
    closestDistance: 'Distance la plus proche',
    soonestDate: 'Date de la plus récente',
    locationAndStores: 'Emplacement et magasins'
};

module.exports = function getResource(label) {
    return resources[label];
};
